module.exports = __webpack_public_path__ + "img/logo_nodecenter.d10f354a.png";